import { BaseMethodReturnType } from '../../../types/commonTypes';
import ConnectionInfoSubsystem from 'src/services/ConnectionInfoSubsystem';
import { INorthboundAPIV1 } from './types';

class NorthboundAPIV1 implements INorthboundAPIV1 {
  async hasInternetAccess(): Promise<BaseMethodReturnType<boolean>> {
    return ConnectionInfoSubsystem.hasInternetAccess();
  }

  async listenHasInternetAccess(
    callback: (hasInternetAccess: boolean) => void
  ): Promise<BaseMethodReturnType<{ remove: () => void }>> {
    return ConnectionInfoSubsystem.listenHasInternetAccess(callback);
  }

  useHasInternetAccess(
    React: any
  ): BaseMethodReturnType<boolean | undefined, { loading: boolean }> {
    return ConnectionInfoSubsystem.useHasInternetAccess(React);
  }
}

const northboundAPIV1 = new NorthboundAPIV1();

export default northboundAPIV1;
